import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getRescueSelector } from '../selectors'
import { setAddToTimeLine } from '../store/rescue.actions'
import { RescueConstants } from '../store/rescue.constants'
import { IRescueState } from '../store/rescue.types'
import { addRescueItem } from '../../../timeline/store/timeline.actions'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveRescue() {
  let rescueState: IRescueState = yield select(getRescueSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    // Filter based on the activations option (this is how NEMSIS wants it)
    rescueState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: rescueState,
      actionField: null,
      filter1Field: null,
      filter2Field: (s) => (s.activations ? s.activations[0]?.id.toString() : null),
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    rescueState = handleNemsisCodeError(error, rescueState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.rescueStateList && pcrDoc.patient?.rescueStateList.length) {
    const index = pcrDoc.patient?.rescueStateList?.findIndex((rescue) => rescue.key === rescueState.key)
    if (index !== -1) {
      pcrDoc.patient.rescueStateList[index] = rescueState
    } else {
      pcrDoc.patient?.rescueStateList.push(rescueState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, rescueStateList: [rescueState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addRescueItem())
  } catch (e) {
    yield put(throwPcrException(`saveRescue() error: ${e}`))
  }
}

export function* saveRescueSaga() {
  yield takeLatest(
    [
      RescueConstants.SAVE_RESCUE,
      RescueConstants.SET_DATE,
      RescueConstants.SET_TIME,
      RescueConstants.SET_DATE_TIME,
      RescueConstants.SET_ASSESSED_BY,
      RescueConstants.SET_RESPONSE,
      RescueConstants.SET_RESPONSE_PNNV,
      RescueConstants.SET_PROCEDURE_COMPLICATIONS,
      RescueConstants.SET_AUTHORIZATION,
      RescueConstants.SET_ATTEMPTS,
      RescueConstants.SET_TYPES,
      RescueConstants.SET_HYDRAULICS,
      RescueConstants.SET_REHAB,
      RescueConstants.SET_TOOLS,
      RescueConstants.SET_ACTIVATIONS,
      RescueConstants.SET_ROLE_PERFORMING,
      RescueConstants.SET_ROLE_PERFORMING_PNNV,
      RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      RescueConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveRescue
  )
}
